import { render, staticRenderFns } from "./RouteSettings.vue?vue&type=template&id=5f28c3d2&scoped=true&"
import script from "./RouteSettings.vue?vue&type=script&lang=js&"
export * from "./RouteSettings.vue?vue&type=script&lang=js&"
import style0 from "./RouteSettings.vue?vue&type=style&index=0&id=5f28c3d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f28c3d2",
  null
  
)

export default component.exports